import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal, Row, Col, InputGroup } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import { Update, findOne } from "../../../utils/apis/roles/roles/index";
import { useForm } from "react-hook-form";
import { HTTPS, Select2Data } from "../../../utils/common";
import { Context } from "../../../utils/context";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
import Loader from "react-js-loader";
import classNames from "classnames";
import { AllPermission } from "../../../utils/apis/common";

function Edit(props) {
  const { UnauthorizedLogOut } = useContext(Context);
  const id = props.show;

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [shimmerLoader, setShimmerLoader] = useState(false);

  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [allPermissions, setAllPermissions] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    setValue,
  } = useForm();

  const GetEditData = async () => {
    if (!id) return;
    setIsLoading(true);

    try {
      const response = await findOne(id);
      const roleData = response?.data?.data;

      if (roleData) {
        reset(roleData);

        let existingIds = [];

        if (roleData.Roles_Permissions?.length > 0) {
          existingIds = roleData.Roles_Permissions.map(
            (item) => item.permission_id || item.id,
          );
        } else if (roleData.permissions?.length > 0) {
          existingIds = roleData.permissions.map(
            (item) => item.permission_id || item.id || item,
          );
        } else if (roleData.permission_ids?.length > 0) {
          existingIds = roleData.permission_ids;
        } else {
          const possibleKeys = Object.keys(roleData).filter(
            (key) =>
              key.toLowerCase().includes("permission") ||
              key.toLowerCase().includes("role_permission"),
          );

          for (const key of possibleKeys) {
            if (Array.isArray(roleData[key]) && roleData[key].length > 0) {
              existingIds = roleData[key].map((item) =>
                typeof item === "object" ? item.permission_id || item.id : item,
              );
              console.log(`✅ Found in ${key}:`, existingIds);
              break;
            }
          }
        }

        if (existingIds.length > 0) {
          setSelectedPermissions(existingIds);
          setValue("permission_id", existingIds);
        } else {
          console.warn("⚠️ No permissions found for this role");
          setSelectedPermissions([]);
          setValue("permission_id", []);
        }
      }
    } catch (error) {
      console.error("❌ Error in GetEditData:", error);
      UnauthorizedLogOut(error);
    } finally {
      setIsLoading(false);
    }
  };

  const GetAllPermission = async () => {
    try {
      const response = await AllPermission();
      if (response?.data?.success) {
        const formatted = await Select2Data(
          response?.data?.data,
          "permission_id",
        );
        setAllPermissions(formatted || []);
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  useEffect(() => {
    GetEditData();
    GetAllPermission();
  }, [id]);

  const handleSelectAll = () => {
    if (selectedPermissions.length === allPermissions.length) {
      setSelectedPermissions([]);
      setValue("permission_id", []);
    } else {
      const allIds = allPermissions.map((p) => p.value);
      setSelectedPermissions(allIds);
      setValue("permission_id", allIds);
    }
  };

  const handleCheckboxChange = (permissionId) => {
    const id = Number(permissionId);
    const updated = selectedPermissions.includes(id)
      ? selectedPermissions.filter((x) => x !== id)
      : [...selectedPermissions, id];

    setSelectedPermissions(updated);
    setValue("permission_id", updated);
  };

  const onSubmit = async (data) => {
    setShimmerLoader(true);
    try {
      const sendData = new FormData();

      sendData.append("name", data.name?.trim() || "");

      if (data.permission_id?.length > 0) {
        data.permission_id.forEach((pid) => {
          sendData.append("permission_id", pid);
        });
      } else {
        sendData.append("permission_id", []);
      }

      const result = await Update(id, sendData);
      const response = result.data;

      if (response?.code === HTTPS.ACCEPTED.code || response?.success) {
        setShowModal({
          code: 200,
          message: "Role updated successfully",
        });

        setTimeout(() => {
          setShowModal({ code: 0, message: "" });
          props.onHide();
          reset();
          setSelectedPermissions([]);
        }, 1800);
      } else {
        setError("name", {
          type: "manual",
          message: response?.message || "Update failed",
        });
      }
    } catch (error) {
      console.error(error);
      setError("name", {
        type: "manual",
        message: error?.response?.data?.message || "An error occurred",
      });
    } finally {
      setShimmerLoader(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        className="Edit_User_Modal modal_holder"
        size="lg"
        centered>
        <Modal_Heading modalHeading="Edit Role" />
        <div className="modal-body-holder">
          <Modal.Body>
            {isLoading ? (
              <div className="text-center py-5">
                <Loader
                  type="bubble-top"
                  bgColor="#000"
                  color="#000"
                  size={60}
                />
              </div>
            ) : (
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                  {/* <Col md={6}> */}
                  <div className="col-md-12 col-sm-12 mt-3">
                    <Form.Group
                      className="form-field"
                      controlId="formBasicEmail">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder="Enter Role Name"
                        {...register("name", {
                          required: "Name is required",
                        })}
                        className={classNames({ "is-invalid": errors.name })}
                      />
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                  {/* </Col> */}

                  {/* Permissions */}
                  <Col md={12} className="mt-4">
                    <div className="main-form-section">
                      <h6 className="mb-3" style={{ color: "#fff" }}>
                        Permissions
                      </h6>

                      <Row className="mb-3">
                        <Col>
                          <Form.Check
                            type="checkbox"
                            label={
                              <span className="text-white">
                                Select All Permissions
                              </span>
                            }
                            checked={
                              allPermissions.length > 0 &&
                              selectedPermissions.length ===
                                allPermissions.length
                            }
                            onChange={handleSelectAll}
                            className="fw-bold"
                          />
                        </Col>
                      </Row>

                      <Row>
                        {allPermissions.length > 0 ? (
                          allPermissions.map((perm) => (
                            <Col md={6} lg={4} key={perm.value}>
                              <Form.Check
                                type="checkbox"
                                label={
                                  <span className="text-white">
                                    {perm.label}
                                  </span>
                                }
                                checked={selectedPermissions.includes(
                                  perm.value,
                                )}
                                onChange={() =>
                                  handleCheckboxChange(perm.value)
                                }
                                className="mb-2"
                              />
                            </Col>
                          ))
                        ) : (
                          <p className="text-muted">No permissions available</p>
                        )}
                      </Row>
                    </div>
                  </Col>
                </Row>

                <div className="modal-footer-holder mt-4 text-center">
                  <Button
                    className="search-btn mx-2"
                    onClick={() => {
                      props.onHide();
                      reset();
                      setSelectedPermissions([]);
                    }}>
                    Cancel
                  </Button>

                  {shimmerLoader ? (
                    <Loader
                      type="bubble-top"
                      bgColor="#FFF"
                      color="#FFF"
                      size={50}
                    />
                  ) : (
                    <Button className="reset-btn mx-2" type="submit">
                      Update Role
                    </Button>
                  )}
                </div>
              </Form>
            )}
          </Modal.Body>
        </div>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code !== 0}
      />
    </>
  );
}

export default Edit;
